import { cn } from '@/utils/tailwind-util';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/outline/index';
import { UserIcon } from '@heroicons/react/solid/index';
import React from 'react';

import { useFetchUserDetail } from '@/services';

/**
 *
 * Nav 우측에 위치한 유저 정보 적힌 버튼
 */

const UserSideButton = React.forwardRef(
  ({ dropdown, onToggleDropdown }, personBtnRef) => {
    const user = useFetchUserDetail();

    return (
      <div
        className={cn(
          'flex items-center group gap-2 px-2 py-6 rounded cursor-pointer hover:bg-primary-100'
        )}
        ref={personBtnRef}
        role="presentation"
        onClick={() => onToggleDropdown('person')}
      >
        <UserIcon className="w-5 text-gray-400 group-hover:text-primary" />
        {user && (
          <span className="text-sm text-gray-700 select-none	whitespace-nowrap group-hover:text-primary">
            {user.userPersonalInfo.name || 'Anonymous'}
          </span>
        )}
        {dropdown.person ? (
          <ChevronUpIcon className="w-3 text-primary" />
        ) : (
          <ChevronDownIcon className="w-3 text-gray-700 group-hover:text-primary" />
        )}
      </div>
    );
  }
);

UserSideButton.displayName = 'UserSideButton';

export default UserSideButton;
